module.exports = __webpack_public_path__ + "img/mypage.63d75512.png";